import React from 'react';
import { Box, Button, TextField, Container } from '@material-ui/core';
import Webcam from 'react-webcam';
import { useFaceDetection } from './useFaceDetection';
import CameraIcon from '@material-ui/icons/Camera';
import DebounceTextField from 'src/components/DebounceTextField';

const FaceDection = () => {
  const { webcamRef, canvasRef, capture, allowCapture } = useFaceDetection();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gridGap={32}
      width="100%"
    >
      <Container maxWidth="sm">
        <Box
          style={{
            position: 'relative',
            width: '100%',
            height: 350
          }}
        >
          <Webcam
            ref={webcamRef}
            audio={false}
            screenshotFormat="image/png"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />

          <canvas
            ref={canvasRef}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }}
          />
        </Box>
      </Container>

      <Box display="flex" justifyContent="center" mt={3}>
        <Button
          onClick={capture}
          variant="outlined"
          color="primary"
          disabled={!allowCapture}
          style={{ borderRadius: '50%', width: 70, height: 70 }}
        >
          <CameraIcon style={{ fontSize: 50 }} />
        </Button>
      </Box>
    </Box>
  );
};

export default FaceDection;
